import { createContext } from "react";
import { API } from "../../api/API";
import { IAPI } from "./APIContextInterfaces";

export const APIContext = createContext<IAPI>({
    API: new API(),
});
